import type { ClientScoreRowData } from '@mastra/client-js';
import { useQuery } from '@tanstack/react-query';

import { captureException } from '../../logger/Logger';
import { useMastraClient } from '../providers/MastraClient';

const THREAD_SCORES_PAGE_SIZE = 100;

export const useListThreadScores = ({
    threadId,
    refetchInterval,
    enabled = true,
}: {
    threadId?: string;
    refetchInterval?: number | false;
    enabled?: boolean;
}) => {
    const mastraClient = useMastraClient();

    return useQuery({
        queryKey: ['thread-scores', threadId],
        refetchInterval,
        queryFn: async (): Promise<ClientScoreRowData[]> => {
            if (threadId == null || threadId === '') {
                return [];
            }

            try {
                const response = await mastraClient.listScoresByRunId({
                    runId: threadId,
                    page: 0,
                    perPage: THREAD_SCORES_PAGE_SIZE,
                });

                return response.scores;
            } catch (err) {
                captureException(err as Error);
                throw err;
            }
        },
        enabled: enabled && threadId != null && threadId !== '',
    });
};
